<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Acompanhamento de Troca de EPI's
      </p>
    </div>
    <section>
      <component-superior
        subPrimeiro="Associações Produtos x Pessoas"
        :primeiro="highlights.quantidade_de_associacoes"
        subSegundo="Dentro do Prazo"
        :segundo="highlights.numero_itens_dentro_prazo"
        subTerceiro="Associações Sem Movimento"
        :terceiro="highlights.associacoes_sem_nunca_ter_pego"
        subQuarto="Prazo Máximo Excedido"
        :quarto="highlights.numero_itens_fora_prazo"
      ></component-superior>
    </section>
    <section>
      <filtros-status-troca-component
        @emitirFiltros="getFiltros"
      ></filtros-status-troca-component>
    </section>

    <section class="q-mt-sm">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        dense
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -5px;
              color: #21324a;
            "
            >Status Retirada: {{ total }}</span
          >
        </template>
        <template v-slot:top-right>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            ><q-btn
              label="Exportar"
              color="secondary"
              icon="file_upload"
              no-caps
              @click="exportar"
          /></span>
        </template>
        <template #body-cell-centro="props">
          <q-td>
            <span>{{ props.row.cost_center_code }}</span>
            <span class="q-ml-sm q-mr-sm">-</span>
            <span>{{ props.row.cost_center_description }}</span>
          </q-td>
        </template>
        <template #body-cell-ultima_retirada="props">
          <q-td>
            <span v-if="props.row.ultima_retirada">{{
              props.row.ultima_retirada
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>

            <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
              props.row.ultima_retirada.split(" ")[1]
            }}</span>
          </q-td>
        </template>

        <template #body-cell-ciclo="props">
          <q-td>
            <span v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>

            <span>
              (Saldo:
              {{
                props.row.quantidade_total_regra -
                props.row.quantidade_retirada
              }})</span
            >
          </q-td>
        </template>
        <template #body-cell-prazo_maximo="props">
          <q-td>
            <span v-if="props.row.prazo_maximo">{{
              props.row.prazo_maximo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>
        <template #body-cell-critico="props">
          <q-td>
            <span v-if="props.row.critico == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
        <template #body-cell-Status="props">
          <q-td>
            <div class="row items-center q-gutter-xs">
              <span
                v-if="props.row.Status == 'ATRASADO'"
                class="row items-center q-gutter-xs"
              >
                <q-icon name="cancel" color="negative" size="18px">
                  <q-tooltip
                    anchor="top middle"
                    self="bottom middle"
                    class="bg-grey-6 text-white"
                  >
                    Vencido
                  </q-tooltip>
                </q-icon>
              </span>

              <span
                v-if="props.row.Status == 'Nunca retirou'"
                class="row items-center q-gutter-xs"
              >
                <q-icon name="adjust" color="grey-6" size="18px">
                  <q-tooltip
                    anchor="top middle"
                    self="bottom middle"
                    class="bg-grey-6 text-white"
                  >
                    Nunca retirado
                  </q-tooltip>
                </q-icon>
              </span>

              <span
                v-if="props.row.Status == 'ATENÇÃO'"
                class="row items-center q-gutter-xs"
              >
                <q-icon name="error" color="warning" size="18px">
                  <q-tooltip
                    anchor="top middle"
                    self="bottom middle"
                    class="bg-grey-6 text-white"
                  >
                    Atenção
                  </q-tooltip>
                </q-icon>
              </span>

              <span
                v-if="props.row.Status == 'OK'"
                class="row items-center q-gutter-xs"
              >
                <q-icon name="check_circle" color="positive" size="18px">
                  <q-tooltip
                    anchor="top middle"
                    self="bottom middle"
                    class="bg-grey-6 text-white"
                  >
                    Em dia
                  </q-tooltip>
                </q-icon>
              </span>
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="true"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "nome",
    label: "Nome",
    field: "nome",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "centro",
    label: "Centro",
    field: "centro",
    align: "left",
  },
  {
    name: "funcao",
    label: "Função / GHE",
    field: "funcao",
    align: "left",
  },
  {
    name: "turno",
    label: "Turno",
    field: "turno",
    align: "left",
  },
  {
    name: "grupo_nome",
    label: "Produto",
    field: "grupo_nome",
    align: "left",
  },
  {
    name: "ultima_retirada",
    label: "Última Retirada",
    field: "ultima_retirada",
    align: "left",
  },
  {
    name: "ciclo",
    label: "Início Próximo Ciclo",
    field: "ciclo",
    align: "left",
  },
  {
    name: "prazo_maximo",
    label: "Retirada Máxima	",
    field: "prazo_maximo",
    align: "left",
  },
  {
    name: "Status",
    label: "Status",
    field: "Status",
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";

import { useRouter } from "vue-router";
import FiltrosStatusTrocaComponent from "../components/filtrosStatusTrocaComponent.vue";
import ComponentSuperior from "../components/componentSuperior.vue";
export default {
  components: { FiltrosStatusTrocaComponent, ComponentSuperior },
  setup() {
    const store = useStore();
    const router = useRouter();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const total = ref("");
    const highlights = ref("");
    const filtrosSave = ref();
    const unidadeDefault = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 15, filtros) => {
      quasar.loading.show();
      // if (
      //   store.state.autenticacao.cliente.includes("staging-vale") ||
      //   store.state.autenticacao.cliente.includes("vale-epiexpress")
      // ) {
      //   quasar.loading.hide();
      //   return;
      // }
      try {
        let response = await store.dispatch("ind/getStatusTroca", {
          vendor_id:
            filtros && filtros.unidade ? filtros.unidade.id : undefined,
          user:
            filtros && filtros.solicitante ? filtros.solicitante : undefined,
          cost_center: filtros && filtros.centro ? filtros.centro : undefined,
          functionn: filtros && filtros.ghe ? filtros.ghe : undefined,
          product_group: filtros && filtros.grupo ? filtros.grupo : undefined,
          search: filtros && filtros.produto ? filtros.produto : undefined,
          status: filtros && filtros.status ? filtros.status.value : undefined,
          regra_critica:
            filtros && filtros.regra ? filtros.regra.value : undefined,
          turno_ids:
            filtros && filtros.turnos && filtros.turnos.length > 0
              ? filtros.turnos.join(",")
              : undefined,
          page: page,
          per_page: rowsPerPage,
        });

        rows.value = response.data.result.data;
        const currentPage =
          response.data.result.page ??
          response.data.result.current_page ??
          page;
        const perPage = response.data.result.per_page ?? rowsPerPage;
        const hasMore = response.data.result.data.length >= perPage;
        pagination.value.rowsPerPage = perPage;
        pagination.value.page = currentPage;
        pagination.value.rowsNumber = hasMore
          ? currentPage * perPage + perPage
          : currentPage * perPage;
        total.value = response.data.result.total ?? "";

        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("ind/exportarStatusTroca", {
          vendor_id: unidadeDefault.value.id,
          user:
            filtrosSave.value && filtrosSave.value.solicitante
              ? filtrosSave.value.solicitante
              : undefined,
          cost_center:
            filtrosSave.value && filtrosSave.value.centro
              ? filtrosSave.value.centro
              : undefined,
          functionn:
            filtrosSave.value && filtrosSave.value.ghe
              ? filtrosSave.value.ghe
              : undefined,
          product_group:
            filtrosSave.value && filtrosSave.value.grupo
              ? filtrosSave.value.grupo
              : undefined,
          search:
            filtrosSave.value && filtrosSave.value.produto
              ? filtrosSave.value.produto
              : undefined,
          status:
            filtrosSave.value && filtrosSave.value.status
              ? filtrosSave.value.status.value
              : undefined,
          regra_critica:
            filtrosSave.value && filtrosSave.value.regra
              ? filtrosSave.value.regra.value
              : undefined,
          turno_ids:
            filtrosSave.value &&
            filtrosSave.value.turnos &&
            filtrosSave.value.turnos.length > 0
              ? filtrosSave.value.turnos.join(",")
              : undefined,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getDadosTopo = async (filtros) => {
      highlights.value = "";
      try {
        const response = await store.dispatch("ind/getStatusTrocaTopo", {
          vendor_id: unidadeDefault.value.id
            ? unidadeDefault.value.id
            : undefined,
          pessoa:
            filtros && filtros.solicitante ? filtros.solicitante : undefined,
          centro_custo: filtros && filtros.centro ? filtros.centro : undefined,
          funcao: filtros && filtros.ghe ? filtros.ghe : undefined,
          grupo: filtros && filtros.grupo ? filtros.grupo : undefined,
          produto: filtros && filtros.produto ? filtros.produto : undefined,
          regra_critica:
            filtros && filtros.regra ? filtros.regra.value : undefined,
          turno_ids:
            filtros && filtros.turnos && filtros.turnos.length > 0
              ? filtros.turnos.join(",")
              : undefined,
        });

        highlights.value = response.data;
        for (const highlightsKey in highlights.value) {
          highlights.value[highlightsKey] =
            highlights.value[highlightsKey].toString();
        }
      } catch (error) {
        highlights.value = "";
        quasar.notify({
          message: "Selecione uma unidade para carregar os highlights",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDadosTopo);

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = store.state.org.unidadeData;
      getDados();
    };
    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(
        pagination.value.page,
        pagination.value.rowsPerPage,
        filtrosSave.value
      );
    };

    const getFiltros = async (filtros) => {
      filtrosSave.value = filtros;

      getDados(1, pagination.value.rowsPerPage, filtrosSave.value);
      getDadosTopo(filtros);
    };

    const movimento = async (id) => {
      router.push({ name: "ind-estoque-movimento", params: { id: id } });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
        getDadosTopo();
      }
    );

    return {
      rows,
      columns,
      pagination,
      disable,
      getDados,
      handleRequest,
      exportar,
      total,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getFiltros,
      highlights,
      movimento,
      filtrosSave,
      tenent: window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : false,
    };
  },
};
</script>

<style>
.status-circulo-troca {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.q-table__top {
  padding: 12px 0px !important;
}
</style>
